import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuthState } from './context';
import { useCredits } from '../hooks/useCredits';
import RoleHelper from '../utils/roleHelper';

const CreditsContext = createContext();

export const useCreditsContext = () => {
    const context = useContext(CreditsContext);
    if (!context) {
        throw new Error('useCreditsContext must be used within a CreditsProvider');
    }
    return context;
};

export const CreditsProvider = ({ children }) => {
    const currentUser = useAuthState();
    const history = useHistory();
    const adminImpersonatingRecruteurId = history.location?.state?.adminImpersonatingRecruteurId;
    
    const creditsHook = useCredits(currentUser, adminImpersonatingRecruteurId, history);
    
    // Refs pour tracker les dernières valeurs et éviter les fetch inutiles
    const lastFetchedUserIdRef = useRef(null);
    const lastFetchedAdminIdRef = useRef(null);

    useEffect(() => {
        const currentUserId = currentUser?.user?.id;
        const currentAdminId = adminImpersonatingRecruteurId;
        
        // Ne fetch que si l'utilisateur-entreprise ou l'admin impersonation a réellement changé
        if (lastFetchedUserIdRef.current !== currentUserId || lastFetchedAdminIdRef.current !== currentAdminId) {
            lastFetchedUserIdRef.current = currentUserId;
            lastFetchedAdminIdRef.current = currentAdminId;
            
            if (RoleHelper.isEntreprise(currentUser) || (adminImpersonatingRecruteurId && RoleHelper.isAdminImpersonatingEntreprise(currentUser, history.location.pathname))) {
                creditsHook.fetchCredits();
            }
        }
    }, [currentUser?.user?.id, adminImpersonatingRecruteurId, history.location.pathname, creditsHook.fetchCredits]);

    return (
        <CreditsContext.Provider value={creditsHook}>
            {children}
        </CreditsContext.Provider>
    );
};
